module.exports = function getResource(label, vars = []) {
    let resources = {
        free: 'FREE',
        billedMonthly: 'billed monthly'
    };
    return resources[label];
};
